export default __webpack_public_path__ + "static/media/kozossegi_energia.ad2c56fc.svg";